import { render, staticRenderFns } from "./Sshi2023Layout.vue?vue&type=template&id=48f27cc8"
import script from "./Sshi2023Layout.vue?vue&type=script&lang=js"
export * from "./Sshi2023Layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports